
















import { Vue, Component } from 'vue-property-decorator';

import sponsorData from '@/../public/json/sponsor.json';

@Component
export default class SponsorFooter extends Vue {
  private sponsors: any = {};

  public mounted () {
    this.getSponsor();
  }

  private getSponsor (): void {
    this.sponsors = sponsorData
      .filter((sponsor) => sponsor.level !== 'media' && sponsor.level !== 'thank')
      .map((sponsor) => {
        return {
          ...sponsor,
          image: `https://sitcon.org/2020/img/sponsors/${sponsor.image}`
        };
      });
  }
}
